/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetTransferLogsQueryResponse, TransfersControllerGetTransferLogsPathParams, TransfersControllerGetTransferLogsQueryParams, TransfersControllerGetTransferLogs401, TransfersControllerGetTransferLogs403 } from "../../models/transfersController/TransfersControllerGetTransferLogs";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transfersControllerGetTransferLogs } from "../../clients/transfersService/transfersControllerGetTransferLogs";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transfersControllerGetTransferLogsQueryKey = (id: TransfersControllerGetTransferLogsPathParams["id"], params: TransfersControllerGetTransferLogsQueryParams = {}) => [{
  url: '/api/v1/transfers/:id/logs',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TransfersControllerGetTransferLogsQueryKey = ReturnType<typeof transfersControllerGetTransferLogsQueryKey>;
export function transfersControllerGetTransferLogsQueryOptions(id: TransfersControllerGetTransferLogsPathParams["id"], params?: TransfersControllerGetTransferLogsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transfersControllerGetTransferLogsQueryKey(id, params);
  return queryOptions<TransfersControllerGetTransferLogsQueryResponse, ResponseErrorConfig<TransfersControllerGetTransferLogs401 | TransfersControllerGetTransferLogs403>, TransfersControllerGetTransferLogsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transfersControllerGetTransferLogs(id, params, config);
    }
  });
}

/**
 * @summary Get transfer run logs
 * {@link /api/v1/transfers/:id/logs}
 */
export function useTransfersControllerGetTransferLogs<TData = TransfersControllerGetTransferLogsQueryResponse, TQueryData = TransfersControllerGetTransferLogsQueryResponse, TQueryKey extends QueryKey = TransfersControllerGetTransferLogsQueryKey>(id: TransfersControllerGetTransferLogsPathParams["id"], params?: TransfersControllerGetTransferLogsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransfersControllerGetTransferLogsQueryResponse, ResponseErrorConfig<TransfersControllerGetTransferLogs401 | TransfersControllerGetTransferLogs403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transfersControllerGetTransferLogsQueryKey(id, params);
  const query = useQuery({
    ...transfersControllerGetTransferLogsQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransfersControllerGetTransferLogs401 | TransfersControllerGetTransferLogs403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}